import { DirectionsBike, FiberManualRecord } from '@mui/icons-material';
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CurrentPContext, MasterContext, MobiOrNotContext } from "../../ContextApi/context";
import utilsRests from "../../_Utils/utilsRests";

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import ConnUrls from "../../Connections/ConnectURL";
import MyDateTime from "../../DTechComp/MyDateTime";
import myFunctions from "../../myFunctions";

const MainTableReservs = (props) => {
    const [master] = useContext(MasterContext);

    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [reserveList, setReserveList] = useState([]);

    useEffect(() => {
        getMRsts();
    }, [])


    const getMRsts = async () => {


        let reservsList = await utilsRests.getTableReservsList();

        setReserveList(reservsList);
    }


    return (
        <div className={"FourMainLnksDiv"}>
            <Swiper
                spaceBetween={mobiOrNot ? 10 : 16}
                slidesPerView={mobiOrNot ? 3 : 6}
                loop={false}
                // onSlideChange={() => console.log('slide change')}
                freeMode={true}
                loopFillGroupWithBlank={false}>

                {
                    reserveList.map((item, index) => {
                        let timing = (item.Delivery?.Time) ? item.Delivery.Time : (item.TakeAway?.Time) ? item.TakeAway.Time : 30;
                        let timingChannel = (item.Delivery?.Time) ? "Deliver" : "Take";
                        timing = myFunctions.checkForDeliverysDelay(master, timing, timingChannel);
                        
                        let priceing = (item.Delivery?.Price) ? item.Delivery.Price : (item.TakeAway?.Price) ? item.TakeAway.Price : 20;

                        //הנקודה הירוקה/אדומה לפי שעות הפתיחה - זו התווית
                        let opHours = MyDateTime.checkIfBetweenHours(item, master);

                        //הזמנת שולחנות לא מציגה רצועת "סגור" בכוונה -
                        //היא לא תלויה בשעות ההזמנות של הערוצים
                        let notGettinOrders = "";
                        return (
                            <SwiperSlide key={index} className={mobiOrNot ? "favBtn" : "NotfavBtn"}>
                                <Link to={`/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`}>
                               

                                    <div className={"imgWrap animate__animated pulseME"}>
                                        {(notGettinOrders != "") ? 
                                        <div  data-nosnippet className={"no-render imgWrapDivClose imgWrapDivCloseSmall"}><span>{notGettinOrders}</span></div> : ""}

                                        <div className={"imgDiv mainFavImgDiv"} style={{ backgroundImage: `url("${ConnUrls.media(item.buissMainImg)}")` }} >

                                        </div>
                                        <div className={"botBlock"}>
                                            <div className={"pgBigTxt bold regular"}>
                                                <span className={`specDot ${!opHours.openOrCLose ? "specDotClose" : ""}`}><FiberManualRecord aria-hidden="true" /></span>
                                                {item.buissName}
                                            </div>
                                            <div className={"pgSmallTxt mediumst"}>
                                                <p>{item.buissKitchType}</p>
                                            </div>

                                            <div className={"pgSmallTxt mediumst"}>
                                                <div className={"theImgwrap"} >
                                                    <div className={"theImg"} style={{ backgroundImage: `url(${ConnUrls.servMediasUrl}PermanentImages/tustus.png")` }}></div>
                                                </div>

                                                <div className={"timeTxt fullWidth"}>
                                                    <div className={"theImg "} >
                                                        <DirectionsBike aria-hidden="true" />
                                                        &nbsp;&nbsp;
                                                        {/* {priceing} ₪  &nbsp;&nbsp; */}
                                                        {(parseInt(timing) + 10) +
                                                            " - " + parseInt(timing)} דק'
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>


                                </Link>
                            </SwiperSlide>
                        )
                    })
                }
                {mobiOrNot ?
                    <>
                        {[...Array(parseInt(reserveList.length / 9) + 1)].map((_, i) => (
                            <SwiperSlide key={reserveList.length + i + 1} className="favBtn spacerfavBtn">
                                <Link to="">
                                    <div className="catBtnMasterWrap">
                                        <img className="prodImage" src={""} alt={currentPage.altTags || currentPage.pageName || ""} />
                                    </div>
                                    <div className="fourMastBtn pointing">{/* Your content here */}</div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </>
                    :
                    <>
                        {[...Array(parseInt(reserveList.length / 18) + 1)].map((_, i) => (
                            <SwiperSlide key={reserveList.length + i + 1} className="favBtn spacerfavBtn">
                                <Link to="">
                                    <div className="catBtnMasterWrap">
                                        <img className="prodImage" src={""} alt={currentPage.altTags || currentPage.pageName || ""} />
                                    </div>
                                    <div className="fourMastBtn pointing">{/* Your content here */}</div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </>
                }
            </Swiper>
        </div>
    )
}

export default MainTableReservs;